<template>
  <div class="">
    <nav-bar />
    <aside-menu :menu="menu" :menu-bottom="menuBottom" />

    <div class="admin-content">
      <transition name="slide" mode="out-in">
        <router-view />
      </transition>
    </div>
    <StockTicker :symbolsList="['AMZN', 'BINANCE:BTCUSDT', 'IC MARKETS:1']" />
  </div>
</template>

<script>
import NavBar from '@/components/theme/NavBar.vue'
import AsideMenu from '@/components/theme/AsideMenu'
import StockTicker from '@/components/admin/dasboard/StockTicker.vue'
import { mapState } from 'vuex'

export default {
  name: 'Admin',
  components: {
    NavBar,
    AsideMenu,
    StockTicker
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('user', ['rol']),
    menuBottom: function() {
      let menuBottom = {
        '': [],
        admin: [
          null,
          [

            {
              routeName: 'admin.settings',
              label: this.$t('Ajustes'),
              icon: 'tune'
            },
            {
              routeName: 'admin.configuration',
              label: this.$t('Configuracion'),
              icon: 'cogs'
            }
          ]
        ],
        corporative_director: [
          null,
          [
            {
              routeName: 'admin.settings',
              label: this.$t('Ajustes'),
              icon: 'tune'
            },
            {
              routeName: 'admin.configuration',
              label: this.$t('Configuracion'),
              icon: 'cogs'
            }
          ]
        ],
        subpartner: [
          null,
          [

            {
              routeName: 'admin.settings',
              label: this.$t('Ajustes'),
              icon: 'tune'
            },
            {
              routeName: 'admin.configuration',
              label: this.$t('Configuracion'),
              icon: 'cogs'
            }
          ]
        ],
        partner: [
          null,
          [
            {
              routeName: 'admin.settings',
              label: this.$t('Ajustes'),
              icon: 'tune'
            },
            {
              routeName: 'admin.configuration',
              label: this.$t('Configuracion'),
              icon: 'cogs'
            }
          ]
        ]
      }

      return menuBottom[this.rol]
    },
    menu: function() {
      let menus = {
        '': [],
        corporative_director: [
         null,
          [
            {
              routeName: 'admin.dashboard',
              label: this.$t('Dashboard'),
              icon: 'view-dashboard'
            },
            {
              routeName: 'admin.enumerates',
              label: this.$t('Enumerados'),
              icon: 'chart-line-variant'
            },
            {
              routeName: 'admin.invitationCodes',
              label: this.$t('Invitaciones'),
              icon: 'ticket-account'
            },
            {
              routeName: 'admin.onBoard.list',
              label: this.$t('Solicitudes'),
              icon: 'arrow-up'
            },
            {
              routeName: 'admin.institutions.list',
              label: this.$t('Instituciones'),
              icon: 'bank'
            },
            {
              routeName: 'admin.users.list',
              label: this.$t('Usuarios'),
              icon: 'account-multiple'
            },
            {
              routeName: 'admin.notifications',
              label: this.$t('Notificaciones'),
              icon: 'bell'
            },
            {
              routeName: 'admin.products',
              label: this.$t('Products'),
              icon: 'view-grid'
            },
            {
              routeName: 'admin.ecobanka_tv',
              label: this.$t('Ecobanka TV'),
              icon: 'television'
            }
          ]
        ],
        partner: [
          null,
          [
            {
              routeName: 'admin.dashboard',
              label: this.$t('Dashboard'),
              icon: 'view-dashboard'
            },
            {
              routeName: 'admin.onBoard.list',
              label: this.$t('Solicitudes'),
              icon: 'arrow-up'
            },
            {
              routeName: 'admin.users.list',
              label: this.$t('Usuarios'),
              icon: 'account-multiple'
            },
            /*
            {
              routeName: 'admin.my_chat',
              label: this.$t('MyChat'),
              icon: 'chat'
            },
            */
            {
              routeName: 'admin.ecobanka_tv',
              label: this.$t('Ecobanka TV'),
              icon: 'television'
            },
            {
              routeName: 'admin.products',
              label: this.$t('Productos'),
              icon: 'view-grid'
            },
            {
              routeName: 'admin.notifications',
              label: this.$t('Notificaciones'),
              icon: 'bell'
            }
          ]
        ],
        subpartner: [
          this.$t('General'),

          [
            {
              routeName: 'admin.dashboard',
              label: this.$t('Dashboard'),
              icon: 'view-dashboard'
            },
            {
              routeName: 'admin.onBoard.list',
              label: this.$t('Solicitudes'),
              icon: 'arrow-up'
            }
          ]
        ],
        admin: [
          null,
          [
            {
              routeName: 'admin.dashboard',
              label: this.$t('Dashboard'),
              icon: 'view-dashboard'
            },
            {
              routeName: 'admin.enumerates',
              label: this.$t('Enumerados'),
              icon: 'chart-line-variant'
            },
            {
              routeName: 'admin.onBoard.list',
              label: this.$t('Solicitudes'),
              icon: 'arrow-up'
            },
            {
              routeName: 'admin.institutions.list',
              label: this.$t('Instituciones'),
              icon: 'bank'
            },
            {
              routeName: 'admin.users.list',
              label: this.$t('Usuarios'),
              icon: 'account-multiple'
            }
          ]
        ]
      }
      return menus[this.rol]
    }
  },
  mounted() {
    this.$store.commit('layout/FULL_PAGE', false)
    this.$store.commit('layout/IS_ASIDE_WIDE_ACTIVE', true)
    this.$jbUtils.toggle(true)
  }
}
</script>

<style>
.table-wrapper {
  border: solid 2px var(--rosa-eco);
  border-radius: 10px;
  overflow: hidden;
  overflow-x: auto;
}
table.is-striped th {
  border-bottom: solid 1px var(--rosa-eco) !important;
}
</style>

<style scoped lang="scss">
/* Page router animation animacion*/
.slide-enter-active,
.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in-out;
  overflow-x: hidden;
}

.slide-enter,
.slide-leave-active {
  opacity: 0;
  transform: translateX(-50px);
}

.admin-content {
  /*height: calc(100% - 75px);*/
  height: calc(100vh - 60px);
  padding-bottom: 37px;
  overflow-y: scroll;

  > div {
    height: 100%;
  }
}
</style>
